/// <reference path="../Container/List/EntryItem.ts" />
namespace HA.Core.HTML {

    import EntryItem = HA.Core.HTML.HAList.EntryItem;

    export class ResultItem extends EntryItem {

    }

}
